import { EqlFieldName } from '@modules/common/constants';
import { QuantifyState } from '@modules/quantify/store/types';
import { EQLProps } from 'v2/core/repository/eql/types';

export function getGroupBy(
  groupBy: QuantifyState['query']['groupBy'],
  metadata: QuantifyState['metadata'],
): EQLProps['groupBy'] {
  if (!groupBy) {
    return undefined;
  }

  const field = groupBy?.field;

  switch (field) {
    case EqlFieldName.Entity: {
      if (metadata.shouldShowCategories) {
        return { entityCategory: true };
      }

      const entitySentiment = false;
      return { entity: !entitySentiment, entitySentiment };
    }
    case EqlFieldName.UserSentiment:
      return { recordSentiment: true };
    case EqlFieldName.Language:
      return { language: true };
    case EqlFieldName.Reason:
      return { reason: true };
    case EqlFieldName.Source:
      return { source: true };
    case EqlFieldName.FeedbackRecords:
      return undefined;
    default:
      return { metadata: field };
  }
}
